module.exports = __webpack_public_path__ + "media/01-hd.bff60f27.mp4";